<template>
  <div class="d-flex justify-center" v-if="length > 0">
    <button
      type="button"
      :class="[curPageIdx === 0 ? 'disabled' : '', 'left-btn']"
      @click="onClickEndBtn('left')"
    >
      <v-icon>mdi-chevron-double-left</v-icon>
    </button>
    <button
      type="button"
      :class="[curPageIdx === 0 ? 'disabled' : '', 'left-btn']"
      @click="onClickPrevBtn"
    >
      <v-icon>mdi-chevron-left</v-icon>
    </button>

    <button
      v-for="(page, idx) in displayedPages"
      :key="page + idx"
      type="button"
      :class="[pagination === page ? 'active-btn' : '', 'page-btn']"
      @click="onClickPageBtn(page)"
    >
      {{ page }}
    </button>

    <button
      type="button"
      :class="[
        totalPageSets <= curPageIdx + 1 ||
        length < totalVisible ||
        pagination === length
          ? 'disabled'
          : '',
        'right-btn',
      ]"
      @click="onClickNextBtn"
    >
      <v-icon>mdi-chevron-right</v-icon>
    </button>
    <button
      type="button"
      :class="[
        length < totalVisible || pagination === length ? 'disabled' : '',
        'right-btn',
      ]"
      @click="onClickEndBtn('right')"
    >
      <v-icon>mdi-chevron-double-right</v-icon>
    </button>
  </div>
</template>

<script>
/** emit 선언 : update-pagination 페이지번호 업데이트 시 핸들러 */
export default {
  props: {
    length: { type: Number, default: 1 }, // 총 페이지 수
    totalVisible: { type: Number, default: 5 }, // 한번에 출력할 페이지 수
    color: { type: String, default: "#5A94ED" },
  },
  data: () => ({
    pagination: 1, // 현재 페이지
    curPageIdx: 0, // 현재 페이지 인덱스
  }),
  computed: {
    // 표시할 페이지 번호 계산
    displayedPages() {
      const startPage = this.curPageIdx * this.totalVisible + 1;
      const endPage = Math.min(startPage + this.totalVisible - 1, this.length);
      const pages = [];
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    },
    // 총 페이지 세트 수 계산
    totalPageSets() {
      return Math.ceil(this.length / this.totalVisible);
    },
  },
  watch: {
    async pagination(val, old) {
      if (val !== old) {
        this.$emit("update-pagination", val);
      }
    },
  },
  methods: {
    onClickEndBtn(type) {
      if (type === "left") {
        this.pagination = 1;
        this.curPageIdx = 0;
      } else {
        this.pagination = this.length;
        this.curPageIdx = this.totalPageSets - 1;
      }
    },
    onClickPageBtn(pageNum) {
      this.pagination = pageNum;
    },
    onClickPrevBtn() {
      if (this.curPageIdx > 0) {
        this.curPageIdx--;
        this.pagination = this.displayedPages[0];
      }
    },
    onClickNextBtn() {
      if (this.curPageIdx < this.length - 1) {
        this.curPageIdx++;
        this.pagination = this.displayedPages[0];
      }
    },
  },
};
</script>

<style scoped lang="scss">
.page-btn,
.right-btn,
.left-btn {
  border-radius: 4px;
  font-size: 1rem;
  height: 34px;
  min-width: 34px;
  margin: 0.3rem;
  padding: 0 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
  box-shadow: rgba(110, 104, 104, 0.137) 0px 0px 0px 1px;
  background-color: white;
  border: 1px solid rgba(227, 231, 233, 0.91);
  &:hover {
    background-color: rgba(227, 231, 233, 0.91);
  }
}
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.active-btn {
  background: #5a94ed;
  color: white;
  &:hover {
    background-color: #4d81cf;
  }
}
</style>
